module.exports = __webpack_public_path__ + "static/media/past-activity.d3d417bf.svg";